// extracted by mini-css-extract-plugin
export var header = "_w6-1";
export var maskBottom = "_w6-6";
export var maskMiddle = "_w6-7";
export var maskTop = "_w6-5";
export var root = "_w6-0";
export var scrollDownButton = "_w6-3";
export var scrollDownButtonHidden = "_w6-4";
export var viewport = "_w6-2";